module.exports = __webpack_public_path__ + "static/CircularStd-Bold-6f4fe3ca482221e7c0d8c1baa5f31100.woff";